const pageNameKey = "otaPendingApprovalByOperator";

export const otaPendingApprovalByOperatorEn = {
  [pageNameKey]: {
    titleTemplateFirmware: "Firmware {itemName} Pending Approval by Operator",
    titleTemplateBackup: "Backup {itemName} Pending Approval by Operator",
    descriptionFirmware:
      "Wait until the Operator accepts the firmware installation, then you can push it to the machine.",
    descriptionBackup:
      "Wait until the Operator accepts the backup installation, then you can push it to the machine.",
    cancelRequestButtonText: "Cancel Request",
    cancelSuccessMessage: "Installation request canceled successfully",
    cancelFailureMessage: "Failed to cancel installation request",
  },
};

export const otaPendingApprovalByOperatorPtBr = {
  [pageNameKey]: {
    titleTemplateFirmware:
      "Firmware {itemName} com aprovacao pendente pelo operador",
    titleTemplateBackup:
      "Backup {itemName} com aprovacao pendente pelo operador",
    descriptionFirmware:
      "Aguarde ate que o Operador aceite a instalacao do firmware, entao voce podera envia-lo para a maquina.",
    descriptionBackup:
      "Aguarde ate que o Operador aceite a instalacao do backup, entao voce podera envia-lo para a maquina.",
    cancelRequestButtonText: "Cancelar solicitacao",
    cancelSuccessMessage: "Solicitação de instalação cancelada com sucesso",
    cancelFailureMessage: "Falha ao cancelar a solicitação de instalação",
  },
};

export const otaPendingApprovalByOperatorDe = {
  [pageNameKey]: {
    titleTemplateFirmware:
      "Firmware {itemName}: Ausstehende Genehmigung durch den Operator",
    titleTemplateBackup:
      "Backup {itemName}: Ausstehende Genehmigung durch den Operator",
    descriptionFirmware:
      "Warten Sie, bis der Operator die Firmware-Installation akzeptiert, dann koennen Sie sie auf die Maschine uebertragen.",
    descriptionBackup:
      "Warten Sie, bis der Operator die Backup-Installation akzeptiert, dann koennen Sie sie auf die Maschine uebertragen.",
    cancelRequestButtonText: "Anfrage abbrechen",
    cancelSuccessMessage: "Installationsanfrage erfolgreich abgebrochen",
    cancelFailureMessage:
      "Installationsanfrage konnte nicht abgebrochen werden",
  },
};

export const otaPendingApprovalByOperatorZhHans = {
  [pageNameKey]: {
    titleTemplateFirmware: "固件 {itemName} 等待操作员批准",
    titleTemplateBackup: "备份 {itemName} 等待操作员批准",
    descriptionFirmware: "请等待操作员接受固件安装，然后您可以将其推送到设备。",
    descriptionBackup: "请等待操作员接受备份安装，然后您可以将其推送到设备。",
    cancelRequestButtonText: "取消请求",
    cancelSuccessMessage: "安装请求已成功取消",
    cancelFailureMessage: "取消安装请求失败",
  },
};

export const otaPendingApprovalByOperatorIt = {
  [pageNameKey]: {
    titleTemplateFirmware:
      "Firmware {itemName} in attesa di approvazione da parte dell'Operatore",
    titleTemplateBackup:
      "Backup {itemName} in attesa di approvazione da parte dell'Operatore",
    descriptionFirmware:
      "Attendi che l'Operatore accetti l'installazione del firmware, quindi potrai inviarlo alla macchina.",
    descriptionBackup:
      "Attendi che l'Operatore accetti l'installazione del backup, quindi potrai inviarlo alla macchina.",
    cancelRequestButtonText: "Annulla richiesta",
    cancelSuccessMessage: "Richiesta di installazione annullata con successo",
    cancelFailureMessage: "Impossibile annullare la richiesta di installazione",
  },
};

export const otaPendingApprovalByOperatorEs = {
  [pageNameKey]: {
    titleTemplateFirmware:
      "Firmware {itemName} con aprobacion pendiente por el Operador",
    titleTemplateBackup:
      "Respaldo {itemName} con aprobacion pendiente por el Operador",
    descriptionFirmware:
      "Espere hasta que el Operador acepte la instalacion del firmware, luego podra enviarlo a la maquina.",
    descriptionBackup:
      "Espere hasta que el Operador acepte la instalacion del respaldo, luego podra enviarlo a la maquina.",
    cancelRequestButtonText: "Cancelar solicitud",
    cancelSuccessMessage: "Solicitud de instalación cancelada correctamente",
    cancelFailureMessage: "No se pudo cancelar la solicitud de instalación",
  },
};

export const otaPendingApprovalByOperatorNl = {
  [pageNameKey]: {
    titleTemplateFirmware:
      "Firmware {itemName} wacht op goedkeuring door operator",
    titleTemplateBackup:
      "Back-up {itemName} wacht op goedkeuring door operator",
    descriptionFirmware:
      "Wacht totdat de Operator de firmware-installatie accepteert, daarna kunt u deze naar de machine pushen.",
    descriptionBackup:
      "Wacht totdat de Operator de back-upinstallatie accepteert, daarna kunt u deze naar de machine pushen.",
    cancelRequestButtonText: "Verzoek annuleren",
    cancelSuccessMessage: "Installatieverzoek succesvol geannuleerd",
    cancelFailureMessage: "Installatieverzoek kon niet worden geannuleerd",
  },
};

export const otaPendingApprovalByOperatorTr = {
  [pageNameKey]: {
    titleTemplateFirmware:
      "Firmware {itemName} Operatör Tarafından Onay Bekleniyor",
    titleTemplateBackup:
      "Yedekleme {itemName} Operatör Tarafından Onay Bekleniyor",
    descriptionFirmware:
      "Operatör ürün yazılımı kurulumunu kabul edene kadar bekleyin, ardından onu makineye gönderebilirsiniz.",
    descriptionBackup:
      "Operatör yedekleme kurulumunu kabul edene kadar bekleyin, ardından bunu makineye gönderebilirsiniz.",
    cancelRequestButtonText: "İsteği İptal Et",
    cancelSuccessMessage: "Yükleme isteği başarıyla iptal edildi",
    cancelFailureMessage: "Yükleme isteği iptal edilemedi",
  },
};
